import { Link } from "react-router-dom";

import { AnnouncementCard } from "@/components/announcements/AnnouncementCard";
import { DevelopmentRow } from "@/components/development/DevelopmentRow";
import { WhatsAppCard } from "@/components/community/WhatsAppCard";
import { ClockHero } from "@/components/prayer/ClockHero";
import { TimetableList } from "@/components/prayer/TimetableList";
import { PlaceholderState } from "@/components/ui/PlaceholderState";
import { Section } from "@/components/ui/Section";
import {
  DEVELOPMENT_PROJECT_LABELS,
  DEVELOPMENT_PROJECT_SLUGS,
} from "@/config/constants";
import type { DevelopmentProject } from "@/data/types";
import { useAnnouncements } from "@/hooks/useAnnouncements";
import { useDevelopmentProjects } from "@/hooks/useDevelopmentProjects";
import { useDisplaySchedule } from "@/hooks/useDisplaySchedule";
import { useNow } from "@/hooks/useNow";

const FALLBACK_PROJECTS: DevelopmentProject[] = DEVELOPMENT_PROJECT_SLUGS.map(
  (slug, i) => ({
    slug,
    title: DEVELOPMENT_PROJECT_LABELS[slug],
    status: "planned",
    order: i,
  }),
);

const moreLink = "text-sm text-masjidGreen hover:underline";

export function HomePage() {
  const now = useNow(1000);
  const { today } = useDisplaySchedule(now);
  const announcements = useAnnouncements();
  const projects = useDevelopmentProjects();

  const displayProjects = (projects.length > 0 ? projects : FALLBACK_PROJECTS).slice(0, 3);
  const previewAnnouncements = announcements.slice(0, 2);

  return (
    <div>
      <Section className="pb-4 pt-2">
        <ClockHero />
      </Section>

      <Section
        title="Today's Timetable"
        eyebrow="Salah"
        action={
          <Link to="/timetable" className={moreLink}>
            Full →
          </Link>
        }
      >
        <TimetableList schedule={today} now={now} />
      </Section>

      <Section
        title="Notices"
        eyebrow="Recent"
        action={
          <Link to="/announcements" className={moreLink}>
            All →
          </Link>
        }
      >
        {previewAnnouncements.length === 0 ? (
          <PlaceholderState
            title="No notices yet"
            message="Announcements from the Imam Sahab and committee will appear here."
          />
        ) : (
          <div className="space-y-3">
            {previewAnnouncements.map((a) => (
              <AnnouncementCard key={a.id} a={a} />
            ))}
          </div>
        )}
      </Section>

      <Section
        title="Masjid Development"
        eyebrow="Projects"
        action={
          <Link to="/development" className={moreLink}>
            All →
          </Link>
        }
      >
        <div className="space-y-3">
          {displayProjects.map((p) => (
            <DevelopmentRow key={p.slug} project={p} />
          ))}
        </div>
      </Section>

      <Section eyebrow="Community">
        <WhatsAppCard />
      </Section>
    </div>
  );
}
